export const NOTIFY_CC = 'treba.shyers@hungerfreeok.org';
export const MAILJET_TEMPLATE_ID = 1324049;

export const CLOUD_FUNCTIONS_SUBMIT_URL =
  'https://us-central1-snap-screener-ok.cloudfunctions.net/submitForm';

export const GSHEETS_SHEET_ID = '1V1vWm9HNuiVOnXYAXoXW5f6KmsoAKjA3En_GYl93kYk';
export const GSHEETS_SHEET_NAME = 'Contacts';
export const GSHEETS_API_KEY = 'AIzaSyAqnGDtQEG4izy6ywynIU1y9ksFNHvPQOs';
